module.exports = {
	"components.CameraCardList.alertNoData": "無資料",
	"components.CameraCardList.buttonCancel": "取消",
	"components.CameraCardList.buttonEdit": "編輯",
	"components.CameraCardList.buttonReplay": "回放",
	"components.CameraCardList.buttonSave": "儲存",
	"components.CameraCardList.labeStoreName": "門市",
	"components.CameraCardList.labelPlaceName": "監控點",
	"components.CameraCardList.labelStatus": "狀態",
	"components.ChangePasswordPanel.alertChangePasswordSucess": "更改成功",
	"components.ChangePasswordPanel.alertTokenError": "Token 錯誤",
	"components.ChangePasswordPanel.buttonRelogin": "重新登入",
	"components.ChangePasswordPanel.buttonSave": "設定",
	"components.ChangePasswordPanel.labelPassword": "密碼",
	"components.ChangePasswordPanel.labelPasswordAgain": "再輸入一次密碼",
	"components.ChangePasswordPanel.titleChangePassword": "重置密碼",
	"components.ChangePasswordPanel.warningPasswordsAreDifferent": "兩次輸入的新密碼不同，重新輸入",
	"components.ChangePasswordPanel.labelOldPassword": "舊密碼",
	"components.ChangePasswordPanel.labelNewPassword": "新密碼",
	"components.ChangePasswordPanel.changepassword_form_title": "密碼變更",
	"components.ChangePasswordPanel.changepassword_form_btnEdit": "送出",
	"components.ChangePasswordPanel.changepassword_form_btnCancel": "取消",
	"components.DatetimePeriod.labelFrom": "從",
	"components.DatetimePeriod.labelTo": "至",
	"components.GroupListPanel.buttonCreate": "新增",
	"components.Header.backToTheTop": "回上層",
	"components.LoginForm.alertLoginFail": "登入失敗",
	"components.LoginForm.alertSentEmail": "密碼重設信件將寄至信箱{email}，請查收您的信件",
	"components.LoginForm.buttonConfirm": "確認",
	"components.LoginForm.buttonLogin": "登入",
	"components.LoginForm.buttonSubmit": "取得新密碼",
	"components.LoginForm.labelEmailOrUsername": "請輸入Email 或是 用戶名稱",
	"components.LoginForm.labelForgotPassword": "忘記密碼?",
	"components.LoginForm.labelRememberMe": "記住我",
	"components.LoginForm.placeholderPassword": "密碼",
	"components.LoginForm.placeholderUsername": "用戶名稱",
	"components.LoginForm.title": "忘記密碼",
	"routes.AccountManagement.components.alertasswordDoesntMatchPleaseEnterAgaian": "兩次輸入的新密碼不同，請重新輸入",
	"routes.AccountManagement.components.buttonCreate": "新增",
	"routes.AccountManagement.components.buttonSave": "儲存",
	"routes.AccountManagement.components.copied": "已複製",
	"routes.AccountManagement.components.developerSettings": "開發者設定",
	"routes.AccountManagement.components.generateApiToken": "產生新 Token",
	"routes.AccountManagement.components.generateApiTokenDescription": "注意! 產生新 token 將會使原先使用的 token 失效",
	"routes.AccountManagement.components.generateApiTokenSuccessMessage": "請立刻複製 token ，離開此頁後將無法再次取得",
	"routes.AccountManagement.components.labelAuhtorizedDevices": "授權使用裝置",
	"routes.AccountManagement.components.labelAuhtorizedFeatures": "授權使用功能",
	"routes.AccountManagement.components.labelEmail": "email",
	"routes.AccountManagement.components.labelPassword": "密碼",
	"routes.AccountManagement.components.labelPleaseEnterPasswordAgain": "再輸入一次密碼",
	"routes.AccountManagement.components.labelUsername": "帳號",
	"routes.AccountManagement.components.linkNotification": "通知設定",
	"routes.AccountManagement.components.linkSetting": "帳號變更",
	"routes.AccountManagement.components.linkSubuser": "子用戶維護",
	"routes.AccountManagement.components.posDeviceTokens": "POS device tokens",
	"routes.AccountManagement.components.roleAdminNotSupportSubuserFeatureMessage": "Admin 帳號不支援子用戶功能，請嘗試以其他管理帳號登入",
	"routes.AccountManagement.components.tdDelete": "刪除",
	"routes.AccountManagement.components.tdEdit": "編輯",
	"routes.AccountManagement.components.thAuthDevices": "授權裝置",
	"routes.AccountManagement.components.thEmail": "Email",
	"routes.AccountManagement.components.thUsername": "用戶名稱",
	"routes.AccountManagement.components.title": "用戶管理",
	"routes.AccountManagement.components.titleCreateSubuser": "新增子用戶",
	"routes.AccountManagement.components.titleDeveloperSettings": "開發者設定",
	"routes.AccountManagement.components.titleEditSubuser": "編輯子用戶",
	"components.Header.logout": "登出",
	"components.Header.back": "區域監控",
	"components.Header.headerMenuUserManagement": "使用者管理",
	"components.Header.headerMenuBedManagement": "床位管理",
	"components.Header.headerMenuPatientManagement": "住民管理",
	"components.Header.headerMenuAreaMonitoring": "區域監控",
	"components.Header.headerMenuChangePassword": "變更密碼",
	"components.Header.headerMenuHistoryQuery": "歷史查詢",
	"components.Header.headerMenuSetting": "系統設定",
	"components.Header.headerMenuVideoWall": "床位監控",
	"routes.PatientMonitoring.components.areaMonitoring": "區域監控",
	"routes.PatientMonitoring.components.realtimeMonitoring": "即時狀態",
	"routes.PatientMonitoring.components.realtimeImage": "即時影像",
	"routes.PatientMonitoring.components.HistorySearching": "歷史查詢",
	"routes.PatientMonitoring.components.bedAlarmSetting": "通知設定",
	"routes.PatientMonitoring.components.bedSetting": "床位設定",
	"routes.PatientMonitoring.components.fullScreen": "全螢幕",
	"routes.PatientMonitoring.components.CloseFullScreen": "關閉全螢幕",
	"routes.PatientMonitoring.components.keyWard": "病房：",
	"routes.PatientMonitoring.components.keyBed": "病床：",
	"routes.PatientMonitoring.components.keyPatientId": "病歷號：",
	"routes.PatientMonitoring.components.patientId": "病歷號：",
	"routes.PatientMonitoring.components.keyPatientName": "姓名：",
	"routes.PatientMonitoring.components.keyMonitorDate": "入院日期：",
	"routes.PatientMonitoring.components.keyDateOfBirth": "出生年月日：",
	"routes.PatientMonitoring.components.keyBedNo": "床號：",
	"routes.PatientMonitoring.components.labelName": "區間查詢",
	"routes.PatientMonitoring.components.labelTo": "至",
	"routes.PatientMonitoring.components.bedcard_state_hr_warm": "心率異常",
	"routes.PatientMonitoring.components.bedcard_state_rr_warm": "呼吸異常",
	"routes.PatientMonitoring.components.bedcard_state_temp_warm": "溫度異常",
	"routes.PatientMonitoring.components.bedcard_state_warm": "體徵異常",
	"routes.PatientMonitoring.components.bedcard_state_offbed": "離床",
	"routes.PatientMonitoring.components.bedcard_state_onbed": "在床",
	"routes.PatientMonitoring.components.bedcard_state_getup": "起身",
	"routes.PatientMonitoring.components.bedcard_state_offline": "設備離線",
	"routes.PatientMonitoring.components.bedcard_state_move": "翻動",
	"routes.PatientMonitoring.components.buttonSearch": "查詢",
	"routes.PatientMonitoring.components.placeholderPleaseSelect": "快速查詢",
	"routes.PatientMonitoring.components.threeDays": "三天",
	"routes.PatientMonitoring.components.oneWeek": "一週",
	"routes.PatientMonitoring.components.oneMonth": "一個月",
	"routes.PatientMonitoring.components.keyHeartRate": "心率",
	"routes.PatientMonitoring.components.keyRespiratoryRate": "呼吸",
	"routes.PatientMonitoring.components.keyTemperature": "溫度",
	"routes.PatientMonitoring.components.keyMovement": "翻動",
	"routes.PatientMonitoring.components.onBed": "在床",
	"routes.PatientMonitoring.components.notOnBed": "離床",
	"routes.PatientMonitoring.components.avg": "平均",
	"routes.PatientMonitoring.components.rrBpm": "次/分",
	"routes.PatientMonitoring.components.heartBpm": "下/分",
	"routes.PatientMonitoring.components.patientmonitoringloading": "載入中",
	"routes.PatientMonitoring.components.QuickSearchTitleHeartRate": "心率",
	"routes.PatientMonitoring.components.QuickSearchTitleRespiratoryRate": "呼吸",
	"routes.PatientMonitoring.components.QuickSearchTitleTemperature": "溫度",
	"routes.PatientMonitoring.components.QuickSearchTitleMovement": "翻動",
	"routes.PatientMonitoring.components.QuickSearchTitleToday": "今日",
	"routes.PatientMonitoring.components.QuickSearchTitleThreeDay": "近三日",
	"routes.PatientMonitoring.components.QuickSearchTitleSevenDay": "近七日",
	"routes.PatientMonitoring.components.HistoryTitleHeartRate": "心率",
	"routes.PatientMonitoring.components.HistoryTitleRespiratoryRate": "呼吸",
	"routes.PatientMonitoring.components.HistoryTitleTemperature": "溫度",
	"routes.PatientMonitoring.components.HistoryTitleMovement": "翻動",
	"routes.PatientMonitoring.components.history_bedno": "床號",
	"routes.PatientMonitoring.components.lastSixtyMins": "最近60分鐘",
	"routes.PatientMonitoring.components.history_timerange": "時間區間",
	"routes.PatientMonitoring.components.history_nodata": "無資料",
	"routes.PatientMonitoring.components.TrendData": "歷史資料",
	"routes.PatientMonitoring.components.history_query": "查詢",
	"routes.PatientMonitoring.components.bedview_modal_title": "即時影像",
	"routes.PatientMonitoring.components.bedsetting_form_btnCreate": "新增",
	"routes.PatientMonitoring.components.bedsetting_form_btnDelete": "刪除",
	"routes.PatientMonitoring.components.bedsetting_form_btnEdit": "確定",
	"routes.PatientMonitoring.components.bedsetting_form_btnCancel": "取消",
	"routes.PatientMonitoring.components.bedsetting_form_tagRoomInfo": "床位資訊",
	"routes.PatientMonitoring.components.bedsetting_form_tagPatientInfo": "住民資訊",
	"routes.PatientMonitoring.components.bedsetting_form_RoomNo": "房號",
	"routes.PatientMonitoring.components.bedsetting_form_BedNo": "床號",
	"routes.PatientMonitoring.components.bedsetting_form_name": "姓名",
	"routes.PatientMonitoring.components.bedAlarmSetting_btnEdit": "確定",
	"routes.PatientMonitoring.components.bedAlarmSetting_btnReset": "重設",
	"routes.PatientMonitoring.components.bedAlarmSetting_btnCancel": "取消",
	"routes.PatientMonitoring.components.bedAlarmSetting_btnSave": "儲存",
	"routes.PatientMonitoring.components.bedAlarmSetting_tagState": "姿態告警通知",
	"routes.PatientMonitoring.components.bedAlarmSetting_tagVitalSign": "體徵告警通知",
	"routes.PatientMonitoring.components.bedAlarmSetting_duration": "持續",
	"routes.PatientMonitoring.components.bedAlarmSetting_title": "床位通知設定",
	"routes.PatientMonitoring.components.bedAlarmSetting_subTitleTemp": "溫度",
	"routes.PatientMonitoring.components.bedAlarmSetting_subTitleRR": "呼吸",
	"routes.PatientMonitoring.components.bedAlarmSetting_subTitleHR": "心率",
	"routes.PatientMonitoring.components.bedAlarmSetting_enable_getup": "啟用起身通知",
	"routes.PatientMonitoring.components.bedAlarmSetting_enable_falldown": "啟用跌倒通知",
	"routes.PatientMonitoring.components.bedevent_to": "至",
	"routes.PatientMonitoring.components.bedevent_timerange": "時間區間",
	"routes.PatientMonitoring.components.bedevent_bedno": "床位",
	"routes.PatientMonitoring.components.bedEvent": "事件查詢",
	"routes.PatientMonitoring.components.bedevent_query": "查詢",
	"routes.PatientMonitoring.components.EventQuery": "事件查詢",
	"routes.PatientMonitoring.components.EventQuery_EndDate": "結束日期",
	"routes.PatientMonitoring.components.EventQuery_StartDate": "開始日期",
	"routes.PatientMonitoring.components.routine": "作息分析",
	"routes.PatientMonitoring.components.routine_bedno": "床號",
	"routes.VideoWall.components.bedSetting": "床位設定",
	"routes.VideoWall.components.bedAlarmSetting": "通知設定",
	"routes.VideoWall.components.areaMonitoring": "區域監控",
	"routes.VideoWall.components.realtimeMonitoring": "即時狀態",
	"routes.VideoWall.components.realtimeImage": "即時影像",
	"routes.VideoWall.components.HistorySearching": "歷史查詢",
	"routes.VideoWall.components.videoWall": "床位監控",
	"routes.VideoWall.components.patientmonitoringloading": "載入中",
	"routes.VideoWall.components.keyHeartRate": "心率",
	"routes.VideoWall.components.keyRespiratoryRate": "呼吸",
	"routes.VideoWall.components.keyTemperature": "溫度",
	"routes.BedSetting.components.bedManagement": "床位管理",
	"routes.BedSetting.components.bedsetting_bedno": "床號",
	"routes.BedSetting.components.bedsetting_roomno": "房號",
	"routes.BedSetting.components.bedsetting_area": "區域",
	"routes.BedSetting.components.bedsetting_type": "類型",
	"routes.BedSetting.components.bedsetting_user": "使用者",
	"routes.BedSetting.components.bedsetting_state": "狀態",
	"routes.BedSetting.components.bedsetting_operation": "操作",
	"routes.BedSetting.components.bedsetting_addNewRoom": "新增房室",
	"routes.BedSetting.components.bedsetting_addNewBed": "新增床位",
	"routes.BedSetting.components.bedsetting_addNewArea": "新增區域",
	"routes.BedSetting.components.bedsetting_form_addNewAreaTitle": "新增區域",
	"routes.BedSetting.components.bedsetting_form_addNewRoomTitle": "新增房室",
	"routes.BedSetting.components.bedsetting_form_addNewBedTitle": "新增床位",
	"routes.BedSetting.components.bedsetting_form_roomName": "房名",
	"routes.BedSetting.components.bedsetting_form_bedKey": "病床代碼",
	"routes.BedSetting.components.bedsetting_form_bedName": "床號",
	"routes.BedSetting.components.bedsetting_form_roomtype": "房型",
	"routes.BedSetting.components.bedsetting_form_roomNo": "房號",
	"routes.BedSetting.components.bedsetting_form_roomstate": "狀態",
	"routes.BedSetting.components.bedsetting_form_operation": "操作",
	"routes.BedSetting.components.bedsetting_form_area": "區域",
	"routes.BedSetting.components.bedsetting_form_keySixA": "(一般)六人房",
	"routes.BedSetting.components.bedsetting_form_keyThreeB": "(安寧)三人房",
	"routes.BedSetting.components.bedsetting_form_keyThreeC": "(呼吸照護)三人房",
	"routes.BedSetting.components.bedsetting_form_keyThreeD": "(特殊)三人房",
	"routes.BedSetting.components.bedsetting_form_bedstatus_booking": "保留中",
	"routes.BedSetting.components.bedsetting_form_bedstatus_none": "空床中",
	"routes.BedSetting.components.bedsetting_form_bedstatus_on": "已入住",
	"routes.BedSetting.components.bedsetting_form_areaTitle": "新增病房/區域",
	"routes.BedSetting.components.bedsetting_form_roomTitle": "新增病室/寢室",
	"routes.BedSetting.components.bedsetting_form_bedTitle": "新增床位",
	"routes.BedSetting.components.bedsetting_form_areaName": "區域名稱",
	"routes.BedSetting.components.bedsetting_form_areaNo": "區域編號",
	"routes.BedSetting.components.bedsetting_form_btnCreate": "新增",
	"routes.BedSetting.components.bedsetting_form_btnDelete": "刪除",
	"routes.BedSetting.components.bedsetting_form_btnEdit": "確認",
	"routes.BedSetting.components.bedsetting_form_btnCancel": "取消",
	"routes.PatientManagement.components.patientManagement": "住民管理",
	"routes.SystemSetting.components.SystemSetting": "系統設定",
	"routes.SystemSetting.components.systemsetting_form_user_buttonCreate": "新建",
	"routes.SystemSetting.components.systemsetting_form_user_buttonEdit": "修改",
	"routes.SystemSetting.components.systemsetting_form_user_buttonCancel": "取消",
	"routes.SystemSetting.components.systemsetting_form_account": "帳號",
	"routes.SystemSetting.components.systemsetting_form_username": "使用者名稱",
	"routes.SystemSetting.components.systemsetting_form_password": "密碼",
	"routes.SystemSetting.components.systemsetting_form_usertype": "類別",
	"routes.SystemSetting.components.systemsetting_form_keyUser": "使用者",
	"routes.SystemSetting.components.systemsetting_form_keyAdmin": "管理員",
	"routes.SystemSetting.components.systemsetting_form_keySysadmin": "系統管理員",
	"routes.SystemSetting.components.systemsetting_alarm_setting": "警報管理",
	"routes.SystemSetting.components.systemsetting_form_alarm_buttonCreate": "新建",
	"routes.SystemSetting.components.systemsetting_form_alarm_buttonEdit": "修改",
	"routes.SystemSetting.components.systemsetting_form_alarm_buttonCancel": "取消",
	"routes.SystemSetting.components.systemsetting_form_alarm_setting": "新增警報",
	"routes.SystemSetting.components.systemsetting_form_alarm_area": "警報區域",
	"routes.SystemSetting.components.systemsetting_form_alarm_keyAll": "全部",
	"routes.SystemSetting.components.systemsetting_form_alarm_range": "正常範圍",
	"routes.SystemSetting.components.systemsetting_form_alarm_keyHR": "心率",
	"routes.SystemSetting.components.systemsetting_form_alarm_keyRR": "呼吸",
	"routes.SystemSetting.components.systemsetting_form_alarm_keyTemp": "溫度",
	"routes.SystemSetting.components.systemsetting_form_alarm_notify": "通知",
	"routes.SystemSetting.components.systemsetting_form_alarm_duration": "持續時間",
	"routes.SystemSetting.components.systemsetting_form_alarm_notifyThreshold": "閥值",
	"routes.SystemSetting.components.systemsetting_tab_alarm": "警報管理",
	"routes.SystemSetting.components.systemsetting_tab_user": "使用者管理",
	"routes.SystemSetting.components.systemsetting_tab_auth": "授權管理",
	"routes.SystemSetting.components.systemsetting_user_addNewUser": "新增用戶",
	"routes.SystemSetting.components.systemsetting_alarm_addNewAlarm": "新增警報",
	"routes.SystemSetting.components.systemsetting_operation": "操作",
	"routes.MPatientMonitoring.components.patientmonitoringloading": "載入中",
	"routes.MPatientMonitoring.components.areaMonitoring": "區域監控",
	"routes.MPatientMonitoring.components.realtimeMonitoring": "即時監控",
	"routes.MPatientMonitoring.components.keyTemperature": "溫度",
	"routes.MPatientMonitoring.components.keyRespiratoryRate": "呼吸",
	"routes.MPatientMonitoring.components.keyHeartRate": "心率",
	"routes.MPatientMonitoring.components.lastSixtyMins": "最近60分鐘",
	"": ""
};


//////////////////
// WEBPACK FOOTER
// ./src/locales/zh.json
// module id = 3471
// module chunks = 6